// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c79836de","453":"73a353d6","455":"37974fd5"}[chunkId] + ".chunk.js";
};